<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div class="d-flex align-items-center gap-2 flex-grow-1">
      <div i18n class="detail-label">Estimated Annual Total</div>
      <img
        [ngbTooltip]="tooltip"
        class="cursor-pointer"
        src="assets/icons/grey/CircleQuestion.svg"
        alt=""
        [style.height.rem]="1.5"
        [style.width.rem]="1.5" />
    </div>
    <div i18n class="detail-value">{{ estimatedAnnualTotal | currency }}</div>
  </div>
</div>

<ng-template #tooltip>
  <div i18n class="tooltip-text">
    This figure reflects all payments made to date in the current year, combined with upcoming recurring and lump sum
    payments planned for this VB account.
  </div>
</ng-template>
